import * as Yup from "yup";
import { Strings } from "@app/constants";

export const yourDetailsSchema = Yup.object()
  .shape({
    firstName: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.firstName)
    ),
    lastName: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.lastName)
    ),
    email: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.email)
    ),
    phoneNumber: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.phone)
    ),
    address: Yup.string().required(
      Strings.validation.fieldRequired(Strings.fields.address)
    ),
    city: Yup.string().required(
      Strings.validation.fieldRequired(Strings.fields.city)
    ),
    state: Yup.string().required(
      Strings.validation.fieldRequired(Strings.fields.state)
    ),
    country: Yup.string().required(
      Strings.validation.fieldRequired(Strings.fields.country)
    ),
    zipCode: Yup.string().required(
      Strings.validation.fieldRequired(Strings.fields.zipcode)
    ),
    drivingLicenseNumber: Yup.string().required(
      Strings.validation.fieldRequired(Strings.validation.drivingLicenseNumber)
    ),
    iAgreeTermsAndConditions: Yup.boolean()
      .oneOf([true], Strings.validation.pleaseCheckTerms)
      .required(Strings.validation.pleaseCheckTerms),
  })
  .required();

export const dateTimeSchema = Yup.object().shape({
  dateAndTime: Yup.date()
    .nullable()
    .required(Strings.validation.pleaseSelectADate),
  time: Yup.string().required(Strings.validation.pleaseSelectATime),
});

export const carSelectionSchema = Yup.object().shape({
  productId: Yup.string().required(Strings.validation.pleaseSelectAVehicle),
});

export const locationSchema = Yup.object().shape({
  selectedLocation: Yup.number()
    .required(Strings.validation.pleaseSelectALocations)
    .typeError(Strings.validation.pleaseSelectA),
});
